export  function validate_string(data) {
    
    if( typeof data === "string" ) return true;

    return "txt157";



};
